{ connect } = require 'react-redux'
{ logout } = require '../actions/auth'
LogoutComponent = require '../components/Logout'

mapDispatchToProps =
	onLogout: logout

Logout = connect(null, mapDispatchToProps)(LogoutComponent)

module.exports = Logout



// WEBPACK FOOTER //
// ./~/cjsx-loader!./frontend/olos/js/containers/Logout.cjsx